const success = {
  main: "#30D28E",
  light: "#30D28E",
  dark: "#30D28E",
};

export { success };
